// extracted by mini-css-extract-plugin
module.exports = {"reddit":"Reddit_reddit__K2_f7","imgScale":"Reddit_imgScale__sBlIw","imgScale2":"Reddit_imgScale2__Kib_x"};